import { Valores } from './../../models/tabla-maestra.model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import {
  ValoresEspecificos,
  FiltroTableMasterGeneral,
  EstructuraEspecifica
} from '@app/shared';

@Injectable()
export class RefactoryMasterTableDataService {
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }

  /**
   * Consulta de los valores de una maestra
   *
   * @param {EstructuraEspecifica} structure
   * @param {FiltroTableMasterGeneral[]} [filterMaster]
   * @returns {Promise<ValoresEspecificos[]>}
   * @memberof RefactoryMasterTableDataService
   */
  getColumnsSpecificMasterTable(
    structure: EstructuraEspecifica,
    filterMaster?: FiltroTableMasterGeneral[],
    idRegistry?: string
  ): Promise<ValoresEspecificos[]> {
    const formData = {
      estructura: structure
    };

    if (filterMaster && filterMaster.length) {
      formData['condicion'] = filterMaster;
    }

    if (idRegistry) {
      formData['id_registro'] = idRegistry;
    }

    return new Promise((resolve, reject) => {
      this.http.post<ValoresEspecificos[]>(this.api.get('masterTableSpecificInformation'), formData).subscribe(
          specificValues => {
            resolve(specificValues);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  /**
   * Actualiza un registro de la tabla maestra dinamica
   *
   * @param {number} idRecord
   * @param {*} data
   * @param {boolean} skipAlert
   * @returns {Observable<boolean>}
   * @memberof RefactoryMasterTableDataService
   */
  updateInformationDynamicTableMaster(
    idRecord: number,
    data: any,
    skipAlert: boolean = false
  ): Observable<boolean> {

    let dataForm: {};

    if (!data['userLogin']) {
      dataForm = {
        datos: data
      };
    } else {
      dataForm = {
        user_login: data['userLogin']
      };
    }

    return new Observable(obs => {
      this.http.skipErrorHandler()
        .put(this.api.get('masterTableInformation', [idRecord]), dataForm, {
          observe: 'response'
        })
        .subscribe(
          res => {
            obs.next(true);
            if (!skipAlert) {
              this.toastr.success('Registro Aactualizado correctamente.', 'Operación exitosa');
            }
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              let message = '';
              if (typeof err.error === 'object') {
                for (const key in err.error) {
                  if (key) {
                    message += key + ': ' + err.error[key];
                  }
                }
              }
              if (message) {
                this.toastr.error(message, 'Error de operación');
              } else {
                this.toastr.error('El registro no se pudo guardar.', 'Error de operación');
              }
            }
            obs.next(false);
            obs.error(err);
          }
        );
    });
  }

  /**
   * Agrega cada registro de la tabla maestra dinamica
   *
   * @param {number} idTableMaster
   * @param {*} data
   * @returns {Observable<boolean>}
   * @memberof RefactoryMasterTableDataService
   */
  addInformationDynamicTableMaster(
    idTableMaster: number,
    data: any,
  ): Observable<boolean> {
    const dataForm = {
      id_maestra: idTableMaster,
      datos: data
    };

    return new Observable(obs => {
      this.http.skipErrorHandler()
        .post(this.api.get('masterTableInformation'), dataForm, {
          observe: 'response'
        })
        .subscribe(
          res => {
            this.toastr.success('Registro guardado correctamente.', 'Operación exitosa');
            obs.next(true);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              let message = '';
              if (typeof err.error === 'object') {
                for (const key in err.error) {
                  if (key) {
                    message += key + ': ' + err.error[key];
                  }
                }
              }
              if (message) {
                this.toastr.error(message, 'Error de operación');
              } else {
                this.toastr.error('El registro no se pudo guardar.', 'Error de operación');
              }
            }
            obs.next(false);
            obs.error(err);
          }
        );
    });
  }

  /**
   * Consulta un registro en especifico
   *
   * @param {number} idRecord
   * @returns {Promise<Valores>}
   * @memberof RefactoryMasterTableDataService
   */
  getInformationDynamicTableMaster(
    idRecord: number,
  ): Promise<Valores> {

    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler()
        .get<Valores>(this.api.get('masterTableInformation', [idRecord]))
        .subscribe(
          valor => {
            resolve(valor);
          },
          err => {
            let message = '';
            for (const key in err.error) {
              if (key) {
                message += key + ': ' + err.error[key];
              }
            }
            if (message) {
              this.toastr.error(message, 'Error de operación');
            } else {
              this.toastr.error('Ha ocurrido un error inesperado.', 'Error de operación');
            }
            reject(err);
          }
        );
    });
  }

  /**
   * Elimina un registro de la tabla maestra dinamica
   *
   * @param {number} idRecord
   * @returns {Observable<boolean>}
   * @memberof RefactoryMasterTableDataService
   */
  deleteInformationDynamicTableMaster(
    idRecord: number
  ): Observable<boolean> {

    return new Observable(obs => {
      this.http.skipErrorHandler()
        .delete(this.api.get('masterTableInformation', [idRecord]), {
          observe: 'response'
        })
        .subscribe(
          res => {
            obs.next(true);
            this.toastr.success('Registro Elimiando correctamente.', 'Operación exitosa');
          },
          err => {
            this.toastr.error('El registro no se pudo eliminar.', 'Error de operación');
            obs.next(false);
            obs.error(err);
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/refactory-master-table/shared/refactory-master-table.data.service.ts